import classNames from "classnames";
import { If } from "react-conditional-components-renderer";
import styles from "./AscAdminDropdown.module.scss";
import { useRef, useState } from "react";
import AscAdminDropdownAndOptionsWrapper, {
  AscAdminDropdownAndOptionsWrapperPropsAlignment,
} from "./AscAdminDropdownAndOptionsWrapper/AscAdminDropdownAndOptionsWrapper";
import {
  AscAdminDropdownOption,
  AscAdminDropdownOptionsContainer,
} from "./AscAdminDropdownOptions/AscAdminDropdownOptions";
import { MoreIcon } from "../AscIcons";

type AscAdminDropdownVariants = "primary" | "secondary";

export interface AscAdminDropdownProps {
  className?: string;
  optionContainerClassName?: string;
  optionItemClassName?: string;
  titleContainerClassName?: string;
  hideMoreIcon?: boolean;
  arrowIcon?: React.ReactNode;
  children?: JSX.Element[];
  title?: React.ReactNode;
  variant?: AscAdminDropdownVariants;
  header?: React.ReactNode;
  fullWidth?: boolean;
  alignment?: AscAdminDropdownAndOptionsWrapperPropsAlignment;
}

function AscAdminDropdown({
  className,
  optionContainerClassName,
  optionItemClassName,
  titleContainerClassName,
  hideMoreIcon = false,
  arrowIcon,
  children,
  title,
  variant = "primary",
  header,
  fullWidth,
  alignment,
}: AscAdminDropdownProps) {
  const toggleIconContainerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  const suffixIcon = arrowIcon ? (
    arrowIcon
  ) : (
    <MoreIcon className={styles.moreIcon} />
  );

  return (
    <AscAdminDropdownAndOptionsWrapper
      alignment={alignment}
      content={
        <AscAdminDropdownOptionsContainer
          header={header}
          children={children}
          className={optionContainerClassName}
          optionItemClassName={optionItemClassName}
          close={close}
        />
      }
      visible={isOpen}
      onClickOutsideContainer={close}
      toggleIconContainerRef={toggleIconContainerRef}
      fullWidth={fullWidth}
      className={classNames(
        styles.ground,
        {
          [styles.isOpen]: isOpen,
          [styles.primary]: variant === "primary",
          [styles.secondary]: variant === "secondary",
          [styles.fullWidth]: fullWidth,
        },
        className
      )}
    >
      <div
        className={classNames(styles.innerContainer, titleContainerClassName)}
        onClick={open}
      >
        <If test={!!title}>
          <div onClick={open} className={styles.title}>
            {title}
          </div>
        </If>

        <If test={!hideMoreIcon}>
          <div ref={toggleIconContainerRef} onClick={open} className={styles.icon}>
            {suffixIcon}
          </div>
        </If>
      </div>
    </AscAdminDropdownAndOptionsWrapper>
  );
}

AscAdminDropdown.Option = AscAdminDropdownOption;

export default AscAdminDropdown;
